export default __webpack_public_path__ + "static/media/refox-web.37023c78.png";